<template>
  <div class="home">

  <h2>Account overview</h2>

  <p class="text-secondary">
      Account reference: {{this.accountNumber }}.
  </p>

  <h4 class="mt-5">Enabled services</h4>

  <div v-if="rawProducts && rawProducts.length > 0">
    <table class="table">
      <tr>
        <th>Description</th>
        <th>Product Name</th>
        <th>last charge date</th>
        <th>frequency</th>
        <th>product date</th>
        <th>created date</th>
        <th>unit price</th>
      </tr>
      <tbody>
        <tr v-for="(service, idx) in rawProducts" :key="idx">
            <td>{{ service.description }}</td>
            <td>{{ service.productName }}</td>
            <td>{{ service.lastChargeDate }}</td>
            <td>{{ service.frequencyDesc }}</td>
            <td>{{ service.productDate }}</td>
            <td>{{ service.createdDate }}</td>
            <td>{{ service.currencySymbol }}{{ service.unitPrice }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h4 class="mt-5">Products</h4>

  <div v-if="products === null || products.length === 0">
    <p>No products enabled for this account.</p>
  </div>

  <div v-if="products != null && products.length > 0">
    <table class="table">
      <tr>
        <th>Active products</th>
        <th></th>
      </tr>

      <tbody>
        <tr v-for="(product, idx) in products" :key="idx">
            <td>{{ product.name }}</td>
            <td><b-badge variant="info" v-if="product.is_enabled">default</b-badge></td>
        </tr>
      </tbody>
    </table>
  </div>

  <br>
  <br>
  <br>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import apiClient from '@/services/api_client_crm.js'

export default {
  name: 'Home',
  data () {
    return {
      rawProducts: [],
      loaded: false
    }
  },
  computed: {
    ...mapGetters([
      'products',
      'accountEnabled',
      'accountNumber'
    ])
  },
  methods: {
    loadRawPayments () {
      this.loaded = false
      try {
        apiClient
          .get('/api/raw-products')
          .then(response => {
            this.rawProducts = response.data
            this.loaded = true
          })
          .catch(err => {
            console.log(err)
            return Promise.reject(err)
          })
      } catch (e) {
        console.error(e)
      }
    }
    // loadRawPayments () {
    //   this.loaded = false
    //   console.log('hooray')
    //   fetch('http://127.0.0.1:2000/v1/api/raw-products').then(response => response.json()).then(data => console.log(data))
    //   console.log('ooot')
    // }
  },
  created () {
    this.loadRawPayments()
  }
}
</script>

<style scoped>

</style>
